import React from 'react';
import './Advisors.css'; // Import external CSS

const advisorList = [
    {
        name: "Mufti Ibrahim Essa",
        title: "Sharia Advisory Board; Faculty Member, Darul Uloom Karachi",
        image: "MuftiIbrahimEssa.webp",
        bio: "Mufti Muhammad Ibrahim Essa is a globally recognized Shariah Scholar in the field of Islamic Banking and Takaful. He has completed his Darse Nizami (Masters in Quran and Sunnah) and Takhassus fil Ifta (Specialization in Islamic Jurisprudence) from Jamiah Darul Uloom Karachi Pakistan. He is currently a Faculty Member of Darul Ifta Jamiah Darul Uloom Karachi Pakistan under the supervision of Mufti Muhammad Taqi Usmani. He has written more than 5,000 fatawa (legal opinions) on a variety of topics regarding Islamic jurisprudence.<br/>Mufti Essa is actively involved in Islamic financing projects globally. He is CEO of Alhamd Sharia Advisory Services and a Sharia Advisor to the Atrium Underwriting Syndicate for Lloyds of London. Mufti Essa is also Chairman of the Sharia Board of United Bank Limited (Pakistan), Chairman of the Sharia Board of Hayat Bank (Uzbekistan), and Sharia Advisor to EFU Insurance and Takaful (Pakistan). He has delivered Islamic Finance presentations in the USA, UK, Australia, New Zealand, Turkey, and Scotland and is an AAOIFI Certified Sharia Advisor and Auditor (CSAA)."
    }
];

function Advisors() {
    return (
        <div className="advisors-container">
            <h2 className="advisors-title">Our Advisors</h2>
            <div className="advisors-grid">
                {advisorList.map((advisor, index) => (
                    <div key={index} className="advisor-card">
                        <div className="advisor-image">
                            <img src={advisor.image} alt={advisor.name} />
                        </div>
                        <h3 className="advisor-name">{advisor.name}</h3>
                        <h4 className="advisor-title">{advisor.title}</h4>
                        <div className="advisor-bio">
                            {advisor.bio.split("<br/>").map((paragraph, idx) => (
                                <p key={idx}>{paragraph}</p>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Advisors;
